import React from "react";
// import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useState } from "react";
import { useParams } from "react-router";
import { useEffect } from "react";
import LoadingPage from "../../../Components/layouts/loading";
import Footer from "../../../Components/Footer/footer";
import { PiPlantLight } from "react-icons/pi";
import StepRoutes from "../../../Routes/steps_routes";
// import { useSelector } from "react-redux";
// import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcOrganization } from "react-icons/fc";
import SimpleButton from "../../../Components/layouts/simple_button";

function ViewSocietyOnboarding() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/society/get-societyOnboarding-byId/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })

      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none m-0 p-0">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcOrganization /> Society Details
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>

          <div className="card my-2">
            <div className="card-header">
              <h2 className="page-title">Society Details</h2>
            </div>
            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Farmer Id</label>
                  <div className="w-100 col">{data?.farmerId || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Society Name</label>
                  <div className="w-100 col">
                    {(data?.societyName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Society Contact Number
                  </label>
                  <div className="w-100 col">
                    {(data?.phone || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Society Address
                  </label>
                  <div className="w-100 col">
                    {(data?.addressLine1 || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data?.addressLine2 && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Society Address 2
                  </label>
                  <div className="w-100 col">
                    {(data?.addressLine2 || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">City</label>
                  <div className="w-100 col">
                    {(data?.city || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">State</label>
                  <div className="w-100 col">
                    {(data?.state || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Picode</label>
                  <div className="w-100 col">
                    {(data?.pincode || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Country</label>
                  <div className="w-100 col">
                    {(data?.country || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Num Of People Size
                  </label>
                  <div className="w-100 col">
                    {data?.numofPeopleSize || "N/A"}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="card-footer">
          <div className="btn-list justify-content-end">
            <SimpleButton
              buttonText="Edit Society Onboard"
              href={`/edit-society-onboardings/${id}`}
            />
            <SimpleButton buttonText="Cancel" type="secondary" />
          </div>
        </div>
        </div>
  

        <Footer />
      </div>
    </div>
  );
}

export default ViewSocietyOnboarding;
